import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "01194da4-2d12-4492-b239-3dcd192853e3",
  publicId: "30",
  name: "Perceptual evaluation",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, principle03, task01, task02],
};

export default lesson;
